/* eslint-disable no-multi-str */
var Weixin = function () {
  window.addEventListener('message', function (e) {
    var msg = e.data;

    if (msg.mtype === 'close') {
      window.MyCallbackTemp(msg.data);
    }
  }, false);
  var portal = {
    "ajaxRequest": window.XMLHttpRequest,
    "openWindow": function openWindow(url, callBack, options) {
      var div = document.createElement("div");
      div.innerHTML = '<a href="' + url + '">temp</a>';
      var alink = div.firstChild;
      url = alink.href;
      var store = {
        height: document.body.style.height,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };

      window.MyCallbackTemp = function (mdata) {
        document.getElementById("__myPop__").remove();
        document.body.style.height = store.height;
        document.body.style.width = store.width;
        document.body.style.overflow = store.overflow;
        callBack(mdata);
      };

      var win = document.getElementById("__myPop__") || document.createElement("div");
      win.id = "__myPop__";
      win.style.zIndex = "9999";
      win.style.width = "100%";
      win.style.height = "100%";
      win.style.position = 'fixed';
      win.style.top = '0';
      win.style.left = '0';
      win.innerHTML = '<iframe src="' + url + '" style="width:100%;height:100%;margin:0;background-color:white;" frameborder="0"></iframe>';
      document.getElementById("__myPop__") || document.body.appendChild(win);
      document.body.style.width = "0px";
      document.body.style.height = "0px";
      document.body.style.overflow = "hidden";
    },
    "closeWindow": function closeWindow(result) {
      window.parent.postMessage({
        mtype: 'close',
        data: result
      }, '*');
    },
    "getDevice": function getDevice() {
      //获取设备信息
      return {
        "getPlatform": function getPlatform(successBack, errorBack) {
          var platform = navigator.platform;
          successBack(platform);
        },
        "getUuid": function getUuid() {
          errorMsg();
        },
        "getDpi": function getDpi() {
          errorMsg();
        }
      };
    },
    "getIM": function getIM() {
      return {
        "openChat": function openChat(address, success, error) {
          errorMsg();
        },
        "openSessionList": function openSessionList(success, error) {
          errorMsg();
        },
        "getUnreadCount": function getUnreadCount(successBack, error) {
          errorMsg();
        }
      };
    },
    "getPhone": function getPhone() {
      //拨打电话
      return {
        "call": function call(phoneNumber, successBack, errorBack) {
          try {
            window.location.href = "tel:" + phoneNumber;
            successBack();
          } catch (e) {
            errorBack(e);
          }
        }
      };
    },
    "getSMS": function getSMS() {
      //发送短信
      return {
        "sendMsg": function sendMsg(phoneNumber, msg, success, error) {
          try {
            window.location.href = "sms:" + phoneNumber + '&body=' + encodeURI(msg);
            success();
          } catch (e) {
            error(e);
          }
        }
      };
    },
    "getAudio": function getAudio() {
      //录音
      return {
        "openRecorder": function openRecorder(successBack, errorBack) {
          errorBack('暂不支持该功能！');
        }
      };
    },
    "getLocation": function getLocation() {
      //获取当前位置
      return {
        "getCurrentPosition": function getCurrentPosition(successBack, errorBack) {
          window.wx.getLocation({
            type: 'wgs84',
            // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function success(res) {
              var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90

              var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。

              var speed = res.speed; // 速度，以米/每秒计

              var accuracy = res.accuracy; // 位置精度

              var position = {
                latitude: latitude,
                longitude: longitude,
                altitude: '',
                accuracy: accuracy,
                altitudeAccuracy: '',
                heading: '',
                speed: speed
              };
              successBack(position);
            },
            fail: function fail(error) {
              errorBack(error);
            }
          });
        }
      };
    },
    "getVibrator": function getVibrator() {
      //设备震动
      return {
        "vibrate": function vibrate(milliseconds, successBack, errorBack) {
          var supportsVibrate = ("vibrate" in navigator);

          if (supportsVibrate) {
            navigator.vibrate(milliseconds);
            successBack();
          } else {
            errorMsg();
          }
        }
      };
    },
    "getEmail": function getEmail() {
      //发送邮件
      return {
        "sendEmail": function sendEmail(address, content, successBack, errorBack) {
          try {
            window.location.href = 'mailto:' + encodeURI(address) + '?body=' + encodeURI(content);
            successBack();
          } catch (e) {
            errorBack(e);
          }
        }
      };
    },
    "getNotification": function getNotification() {
      //提供通知
      return {
        "notice": function notice(id, title, content, clickUrl) {
          errorMsg();
        },
        "scheduleNotice": function scheduleNotice(id, title, content, firstTime, period, clickUrl) {
          errorMsg();
        },
        "cancelNotice": function cancelNotice(id) {
          errorMsg();
        }
      };
    },
    "getNews": function getNews() {
      //访问本地资讯
      return {
        "showColumnList": function showColumnList(siteId, columnId, columnName) {
          errorMsg();
        },
        "showNewsDetail": function showNewsDetail(siteId, siteName, articleId, articleTitle, url) {
          errorMsg();
        }
      };
    },
    "getCamera": function getCamera() {
      //拍照
      return {
        "takePicture": function takePicture(successBack, errorBack) {
          window.wx.chooseImage({
            count: 1,
            // 默认9
            sizeType: ['original', 'compressed'],
            // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'],
            // 可以指定来源是相册还是相机，默认二者都有
            success: function success(res) {
              var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片

              window.wx.getLocalImgData({
                localId: localIds[0],
                // 图片的localID
                success: function success(res) {
                  var localData = res.localData; // localData是图片的base64数据，可以用img标签显示

                  var data = {
                    pic: localData,
                    fileName: ''
                  };
                  successBack(data);
                }
              });
            },
            fail: function fail(e) {
              errorBack(e);
            }
          });
        },
        "takePhoto": function takePhoto(successBack, errorBack) {
          window.wx.chooseImage({
            count: 1,
            // 默认9
            sizeType: ['original', 'compressed'],
            // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['camera'],
            // 可以指定来源是相册还是相机，默认二者都有
            success: function success(res) {
              var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片

              window.wx.getLocalImgData({
                localId: localIds[0],
                // 图片的localID
                success: function success(res) {
                  var localData = res.localData; // localData是图片的base64数据，可以用img标签显示

                  var data = {
                    pic: localData,
                    fileName: ''
                  };
                  successBack(data);
                }
              });
            },
            fail: function fail(e) {
              errorBack(e);
            }
          });
        }
      };
    },
    "getUser": function getUser() {
      //获取用户信息
      return {
        "showUserDetail": function showUserDetail(userId, userName) {
          errorMsg();
        }
      };
    },
    "getScan": function getScan() {
      //扫描二维码
      return {
        "scan2DBarCode": function scan2DBarCode(successBack, errorBack) {
          window.wx.scanQRCode({
            needResult: 1,
            // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode", "barCode"],
            // 可以指定扫二维码还是一维码，默认二者都有
            success: function success(res) {
              var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果

              var code = {
                code: result
              };
              successBack(code);
            },
            fail: function fail(e) {
              errorBack(e);
            }
          });
        }
      };
    },
    "getLog": function getLog() {
      //保存日志
      return {
        "log": function log(content, successBack, errorBack) {
          try {
            var div = document.createElement('div');
            div.style.display = 'none';
            div.innerHTML = content;
            document.body.appendChild(div);
            successBack();
          } catch (e) {
            errorBack(e);
          }
        },
        "error": function error(content) {}
      };
    },
    "getSystem": function getSystem() {
      //提供与操作系统相关的能力
      return {
        "startActivity": function startActivity(intent, errorBack, successBack) {
          errorMsg();
        },
        "openSchema": function openSchema(schema, errorBack, successBack) {
          errorMsg();
        },
        "openFeedback": function openFeedback(errorBack, successBack) {
          errorMsg();
        }
      };
    },
    "getCryptor": function getCryptor() {
      //提供加密解密能力
      return {
        "RSA": function RSA(data, pubKey, success, error) {
          errorMsg();
        }
      };
    }
  };

  function errorMsg() {
    alert("暂不支持该功能！");
    return false;
  }

  function openPopWindow(con, btn_con) {
    //弹窗
    var div = document.createElement('div');
    div.innerHTML = '<div id="ly_zhezhao" style="display:block;background:rgba(0,0,0,0.3);width:100%;height:100%;position:fixed;"></div>\
            <div id="ly_model" style="display:block;background:white;width:400px;height:250px;position:absolute;left:50%;top:50%;margin-left:-200px;margin-top:-125px;">\
            <div class="" style="position: absolute;top: 35%;left: 33%;font-size: 35px;">\
            <div class="">' + con + '</div>\
            <button id="stopRecord" style="margin-top: 35px;font-size: 35px;">' + btn_con + '</button>\
            </div>\
            <span id="ly_close" style="position:absolute;left:350px;top:10px;font-size:20px;width:20px;height:20px;background:skyblue;cursor:pointer;">X</span>\
            </div>';
    var first = document.body.firstChild; //得到页面的第一个元素

    document.body.insertBefore(div, first); //document.body.appendChild(div);

    var mask = document.getElementById("ly_zhezhao");
    var login = document.getElementById("ly_model");
    var close_login = document.getElementById("ly_close");

    close_login.onclick = function () {
      mask.style.display = "none";
      login.style.display = "none";
    };
  }

  portal.openPopWindow = openPopWindow;
  return portal;
}();

export default Weixin;